export default __webpack_public_path__ + "static/media/w_m_2019_a.9756ea9a.jpg";